module.exports = __webpack_public_path__ + "img/logo.dbc0e0c5.png";